import { getLabelColor, LABEL_TEXT_COLOR } from '../../../Label'
import { TableCellText } from '../../TableCellText'
import { TableCellBase } from '../TableCellBase'
import { TableEmptyCell } from '../TableEmptyCell'

import * as styles from './TableLabelCell.module.css'

function TableLabelCell({
  done,
  showTooltip,
  textCellProps,
  tooltip,
  unread,
  value,
  ...cellProps
}) {
  return value?.name ? (
    <TableCellBase {...cellProps}>
      <TableCellText
        {...textCellProps}
        className={styles.TableLabelCell}
        done={done}
        showTooltip={showTooltip}
        style={{
          backgroundColor: getLabelColor(value),
          color: LABEL_TEXT_COLOR,
        }}
        tooltip={tooltip}
        unread={unread}
        value={value?.name}
      />
    </TableCellBase>
  ) : (
    <TableEmptyCell {...cellProps} unread={unread} />
  )
}

export default TableLabelCell
